import styles from "./index.module.less";
import { Flex } from "antd";
import P1Content from "@/components/P1Content";
import data from "../data";
import { isMobile } from "@/utils";

import p2Img1 from "./imgs/p2_img1.png";
import p2Img2 from "./imgs/p2_img2.png";
import p3Img1 from "./imgs/p3_img1.png";
import p6Img1 from "./imgs/p6_img1.png";
import banner from "./imgs/banner.png";
const MobileGeo = () => {
  return (
    <div className={styles.geo}>
      <div className={styles.p1}>
        <P1Content title={data.p1.title} subtitle={data.p1.subtitle} style={{
            backgroundImage: `url(${banner})`,
          }} />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <div className={styles.p2_title}>{data.p2.title}</div>
          <Flex gap={"0.08rem"} vertical>
            <img src={p2Img1} />
            <img src={p2Img2} />
          </Flex>
          <div className={styles.p2_subtitle}>{data.p2.mobile_subtitle}</div>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <img src={p3Img1} />
        </div>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>{data.p4.mobile_title}</div>
          <div className={styles.p4_list}>
            {data.p4.list.map((item, index) => (
              <div key={index} className={styles.p4_item}>
                <img src={item.img} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.p5}>
        <div className={styles.p5_inner}>
          <div className={styles.p5_title}>{data.p5.title}</div>
          <div className={styles.p5_list}>
            {data.p5.list.map((item, index) => {
              return (
                <Flex vertical key={index} className={styles.p5_item}>
                  <div className={styles.p5_item_title}>{item.title}</div>
                  <img src={item.img} />
                </Flex>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.p6}>
        <div className={styles.p6_inner}>
          <div className={styles.p6_title}>{data.p6.mobile_title}</div>
          <img src={p6Img1} />
          <div className={styles.p6_subtitle}>{data.p6.subtitle}</div>
        </div>
      </div>
    </div>
  );
};
export default MobileGeo;
